import './nav.js';
import './swiper-bundle.js';
import './galleryswiper_init.js';

import './specialswiper_init.js';

var fromTop = 200;

(function($) {

   function checkScroll() {
      if ($(window).scrollTop() > fromTop) {
         $('body').addClass("scrolled");
      } else {
         $('body').removeClass("scrolled");
      }
   }

   checkScroll();

   $(window).on("resize scroll", checkScroll);

})(jQuery);
